import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'orange' | 'navy';
  onClick?: () => void;
};
const variants = {
  orange: 'bg-accent text-white shadow-[0_14px_30px_rgba(241,96,13,.34)] hover:bg-accent-dark focus:ring-accent/40',
  navy: 'bg-primary text-white shadow-[0_14px_30px_rgba(11,32,56,.32)] hover:bg-primary-dark focus:ring-primary/30'
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  variant = 'orange',
  onClick
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-xl px-7 py-4 text-center text-base font-extrabold uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus:ring-4 ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-251" data-mp="1eifbhikwa0fl">
      {children}
    </motion.a>;
}